export const textStyles = isOutgoing => ({
  p: 2,
  width: 'auto',
  maxWidth: '791px',
  background: `linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2))`,
  backgroundColor: isOutgoing ? 'background.default' : 'secondary.main',
  borderRadius: isOutgoing ? '3px 10px 10px 10px' : '10px 3px 10px 10px',
  display: 'inline',
  ml: isOutgoing ? 0 : 'auto',
  mr: isOutgoing ? 'auto' : 0,
  whiteSpace: 'pre-line',
});
